import { Token } from 'sdk'
import { BASE_EXCHANGE_URL } from 'config'

export const DMD: { [chainId: number]: Token } = {
  250: new Token(250, '0x90E892FED501ae00596448aECF998C88816e5C0F', 18, 'DMD', 'DarkMatterDefi Token'),
  4002: new Token(4002, '0x050a71b60E0dd4F0556123C52a0F74b841DC0567', 18, 'DMD', 'DarkMatterDefi Token'),
}

export const WFTM: { [chainId: number]: Token } = {
  250: new Token(250, '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83', 18, 'WFTM', 'Wrapped FTM'),
  4002: new Token(4002, '0x07B9c47452C41e8E00f98aC4c075F5c443281d2A', 18, 'WFTM', 'Wrapped FTM'),
}

export const DAI = new Token(250, '0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E', 18, 'DAI', 'Dai Stablecoin')
export const USDT = new Token(250, '0x049d68029688eAbF473097a2fC38ef61633A3C7A', 18, 'USDT', 'Tether USD')
export const UST = new Token(250, '0x23396cF899Ca06c4472205fC903bDB4de249D6fC', 18, 'UST', 'Wrapped UST Token')
export const ETH = new Token(250, '0x2170Ed0880ac9A755fd29B2688956BD959F933F8', 18, 'ETH', 'Binance-Peg Ethereum Token')
export const USDC = new Token(250, '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', 18, 'USDC', 'Binance-Peg USD Coin')

const tokens = {
  dmd: {
    symbol: 'DMD',
    address: {
      250: '0x90E892FED501ae00596448aECF998C88816e5C0F',
      4002: '0x6E13a8aeEc12E8F7C2D5b15a9E423284eF54d248',
    },
    decimals: 18,
    projectLink: 'https://www.dmu.zone',
  },
  dai: {
    symbol: 'DAI',
    address: {
      250: '0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E',
      4002: '0xc9baa8cfdde8e328787e29b4b078abf2dadc2055',
    },
    decimals: 18,
    projectLink: 'https://makerdao.com/en',
  },
  usdc: {
    symbol: 'USDC',
    address: {
      250: '0x04068DA6C83AFCFA0e13ba15A6696662335D5B75',
      4002: '0x980a5afef3d17ad98635f6c5aebcbaeded3c3430',
    },
    decimals: 6,
    projectLink: 'https://www.circle.com/en/usdc',
  },
  ftm: {
    symbol: 'FTM',
    address: {
      250: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://fantom.foundation',
  },
  wftm: {
    symbol: 'WFTM',
    address: {
      250: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://fantom.foundation',
  },
  usdt: {
    symbol: 'USDT',
    address: {
      250: '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
      4002: '0xD9fcf2A2E4343F4b1e6e6c9cbe47cC1E4C399a4B',
    },
    decimals: 6,
    projectLink: 'https://tether.to',
  },
  eth: {
    symbol: 'ETH',
    address: {
      250: '0x74b23882a30290451A17c44f4F05243b6b58C76d',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://ethereum.org/en',
  },
  bnb: {
    symbol: 'BNB',
    address: {
      250: '0xD67de0e0a0Fd7b15dC8348Bb9BE742F3c5850454',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://www.binance.com/en',
  },
  btc: {
    symbol: 'BTC',
    address: {
      250: '0x321162Cd933E2Be498Cd2267a90534A804051b11',
      4002: '',
    },
    decimals: 8,
    projectLink: 'https://bitcoin.org/en',
  },
  sushi: {
    symbol: 'SUSHI',
    address: {
      250: '0xae75A438b2E0cB8Bb01Ec1E1e376De11D44477CC',
      4002: '',
    },
    decimals: 8,
    projectLink: 'https://sushi.com',
  },
  crv: {
    symbol: 'CRV',
    address: {
      250: '0x1E4F97b9f9F913c46F1632781732927B9019C68b',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://curve.fi',
  },
  yfi: {
    symbol: 'YFI',
    address: {
      250: '0x29b0Da86e484E1C0029B56e817912d778aC0EC69',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://yearn.finance',
  },
  mim: {
    symbol: 'MIM',
    address: {
      250: '0x82f0B8B456c1A451378467398982d4834b6829c1',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://abracadabra.money',
  },
  boo: {
    symbol: 'BOO',
    address: {
      250: '0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE',
      4002: '',
    },
    decimals: 18,
    projectLink: `${BASE_EXCHANGE_URL}/`,
  },
  cgs: {
    symbol: 'CGS',
    address: {
      250: '0x5a2e451Fb1b46FDE7718315661013ae1aE68e28C',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://fantomapp.cougarswap.io',
  },
  max: {
    symbol: 'MAX',
    address: {
      250: '0x287A3f943Db1C053c3e79d2f211FFE5c795b978B',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://maximum.farm',
  },
  dola: {
    symbol: 'DOLA',
    address: {
      250: '0x3129662808bEC728a27Ab6a6b9AFd3cBacA8A43c',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://www.inverse.finance',
  },
  magik: {
    symbol: 'MAGIK',
    address: {
      250: '0x87a5C9B60A3aaf1064006FE64285018e50e0d020',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://magik.finance',
  },
  r4id: {
    symbol: 'R4ID',
    address: {
      250: '0x70f52878ca86c5f03d603CDDA414295EE410E8f3',
      4002: '',
    },
    decimals: 18,
    projectLink: 'http://www.raiders-nft.com',
  },
  pgunk: {
    symbol: 'PGUNK',
    address: {
      250: '0xf8Fc059dAfDCe4EF2EdFc72cbBAF410d7531E610',
      4002: '',
    },
    decimals: 9,
    projectLink: 'https://fantomon.net',
  },
  egunk: {
    symbol: 'EGUNK',
    address: {
      250: '0x19840d508904587E08f262F518dA078bd4c560bf',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://fantomon.net',
  },
  nips: {
    symbol: 'NIPS',
    address: {
      250: '0x3a6a2f68F2d556446348028Bc215d2F17Cb5cc49',
      4002: '',
    },
    decimals: 9,
    projectLink: 'https://nipplelabs.finance',
  },
  slurp: {
    symbol: 'SLURP',
    address: {
      250: '0x26AeB3441428eeAf7D653e9A5B455c57Dd8d8EeB',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://slurp.wtf',
  },
  snt: {
    symbol: 'SNT',
    address: {
      250: '0x69D17C151EF62421ec338a0c92ca1c1202A427EC',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://novanetwork.io',
  },
  reaper: {
    symbol: 'REAPER',
    address: {
      250: '0x117dB78176C8eDe4F12fCd29d85Cd96b91A4cbBb',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://www.grim.finance',
  },
  yoshi: {
    symbol: 'yoshi',
    address: {
      250: '0x3dc57b391262e3aae37a08d91241f9ba9d58b570',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://yoshi.exchange',
  },
  devil: {
    symbol: 'DEVIL',
    address: {
      250: '0x174c7106AEeCdC11389f7dD21342F05f46CCB40F',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://www.devilfinance.io',
  },
  ape: {
    symbol: 'APE',
    address: {
      250: '0x2d72A97a31Dc920dB03330780d30074626e39C8A',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://apecoin.com',
  },
  ham: {
    symbol: 'HAM',
    address: {
      250: '0x20AC818b34A60117E12ffF5bE6AbbEF68BF32F6d',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://hamster.money',
  },
  ust: {
    symbol: 'UST',
    address: {
      250: '0x846e4D51d7E2043C1a87E0Ab7490B93FB940357b',
      4002: '',
    },
    decimals: 6,
    projectLink: 'https://www.terra.money',
  },
  luna: {
    symbol: 'LUNA',
    address: {
      250: '0x593AE1d34c8BD7587C11D539E4F42BFf242c82Af',
      4002: '',
    },
    decimals: 6,
    projectLink: 'https://www.terra.money',
  },
  ring: {
    symbol: 'RING',
    address: {
      250: '0x582423C10c9e83387a96d00A69bA3D11ee47B7b5',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://www.ring.financial',
  },
  gem: {
    symbol: 'GEM',
    address: {
      250: '0x42e270Af1FeA762fCFCB65CDB9e3eFFEb2301533',
      4002: '',
    },
    decimals: 18,
    projectLink: 'https://expand.org',
  },
}

export default tokens
